<template>
  <div class="text-xl font-bold title-color">
    Comment livez votre nom de domaine à nos serveurs&nbsp;?
  </div>
  <div class="py-2"></div>
  <div class="">1. Sélectionner votre registraire de noms de domaine</div>
  <div class="flex gap-3">
    <div
      class="h-24 w-24 rounded-lg border-2 cursor-pointer duration-300"
      @click="activeInstructionsHostingProvider = 'namecheap'"
      :class="{
        'border-primary bg-primary-100':
          activeInstructionsHostingProvider == 'namecheap',
        'bg-gray-100': activeInstructionsHostingProvider !== 'namecheap',
      }"
    >
      <img
        class="w-full h-full object-contain p-2"
        src="/images/hosting/namecheap.png"
        alt=""
      />
    </div>
    <div
      class="h-24 w-24 rounded-lg border-2 cursor-pointer duration-300"
      @click="activeInstructionsHostingProvider = 'ovh'"
      :class="{
        'border-primary bg-primary-100':
          activeInstructionsHostingProvider == 'ovh',
        'bg-gray-100': activeInstructionsHostingProvider !== 'ovh',
      }"
    >
      <img
        class="w-full h-full object-contain p-2"
        src="/images/hosting/ovh.png"
        alt=""
      />
    </div>
  </div>
  <div class="py-2"></div>
  <div>
    <div v-if="activeInstructionsHostingProvider == 'namecheap'">
      <div>
        <a class="underline" target="_blank"
          href="https://www.namecheap.com/support/knowledgebase/article.aspx/767/10/how-to-change-dns-for-a-domain/"
          >2. Visitez ce lien qui détail comment créer un enregistrement CNAME
        </a>
      </div>
    </div>
    <div v-if="activeInstructionsHostingProvider == 'ovh'">
      <div>
        <a class="underline" target="_blank"
          href="https://help.ovhcloud.com/csm/en-ie-email-cname-record?id=kb_article_view&sysparm_article=KB0053245"
          >2. Visitez ce lien qui détail comment créer un enregistrement CNAME
        </a>
      </div>
    </div>
  </div>
  <div v-if="activeInstructionsHostingProvider">
    <div class="py-2"></div>
    2. Créez un enrégistrement CNAME avec la valeur suivante: <br />
    <span @click="copyDomainName" class="cursor-pointer">
      <span class="font-bold title-color">apis.ecoxurf.com</span>
      <img class="inline-block w-5 h-5" src="@/assets/images/all/copy.svg" />
    </span>
  </div>
  <div v-if="activeInstructionsHostingProvider">
    <div class="py-2"></div>
    3. Mettez comme host la valeur suivante
    <span @click="copyDomainHost" class="cursor-pointer">
      <span class="font-bold title-color">{{ host }}</span>
      <img class="inline-block w-5 h-5" src="@/assets/images/all/copy.svg" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'customDomainInstructions',
  components: {},
  props: {
    domainName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeInstructionsHostingProvider: '',
    }
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    copyDomainName() {
      this.$Commons.copy(`apis.ecoxurf.com`, 'Copié avec succès')
    },
    copyDomainHost() {
      this.$Commons.copy(this.host, 'Copié avec succès')
    },
  },
  computed: {
    host() {
      return this.domainName.replace(/((.+)\.)?.+?\..+/, '$2')
    },
  },
}
</script>

<style>
/* Style pour les toggles (switch) */
.switch {
  position: relative;
  display: inline-block;
  min-width: 5rem;
  width: 5rem;
  height: 3rem;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 3rem;
}

.slider:before {
  position: absolute;
  content: '';
  height: 2rem;
  width: 2rem;
  left: 0.5rem;
  bottom: 0.5rem;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:checked + .slider:before {
  transform: translateX(2rem);
}

/* Style pour le bouton rond */
.slider.round {
  border-radius: 3rem;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
